<div class="lua-loader-horizontal">
  <div class="progress-bar">
    <div class="progress" [ngClass]="{ indeterminateMode: !progressBar }"></div>
  </div>
  <small *ngIf="progressBar && targetProgress > 0" class="label"
    >{{ initialProgress }} / {{ targetProgress }}</small
  >
  <small *ngIf="progressBar && targetProgress === 0" class="label"></small>
</div>
